import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { upgradeDataPropsInterface } from '../../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { GetACallSection } from './GetACallSection';
import EmailModal from '../EmailModal';
import MeetingModal from '../MeetingModal';
import { StyledModal } from '../../common/components/StyledModal';
import { AssignableModalBody } from './AssignableModalBody';
import { MODAL_TYPES } from '../constants';
import { submitPql } from '../../pql/submitPql';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { trackPricingPagePql } from '../../utils/metricUtils';
const {
  ASSIGNABLE,
  GET_A_CALL,
  MEETING,
  EMAIL
} = MODAL_TYPES;
export const AssignableModal = ({
  handleIframeSizeChange,
  hideBackground,
  onClose,
  ModalComponent,
  _overrideModalHeaderText,
  _overrideCommunicationMethodKey,
  upgradeData,
  isFreeUser,
  modalRoot,
  isUpgradePoint,
  repInfo
}) => {
  const [currentModalView, setCurrentModalView] = useState(_overrideCommunicationMethodKey || ASSIGNABLE);
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint), {
      repName: getRepName(repInfo)
    }));
    submitPql(Object.assign({}, upgradeData, {
      isRetail: false,
      isAssignable: true,
      repInfo
    }));
    trackPricingPagePql(upgradeData.app);
  }, [isUpgradePoint, upgradeData, repInfo]);
  const commonProps = {
    hideBackground,
    onClose,
    upgradeData,
    isUpgradePoint,
    repInfo
  };

  if (currentModalView === MEETING) {
    return /*#__PURE__*/_jsx(MeetingModal, Object.assign({}, commonProps));
  }

  if (currentModalView === EMAIL) {
    return /*#__PURE__*/_jsx(EmailModal, Object.assign({}, commonProps));
  }

  const handleBackClick = () => {
    handleIframeSizeChange(ASSIGNABLE);
    setCurrentModalView(ASSIGNABLE);
  };

  const optionalProps = modalRoot ? {
    rootNode: modalRoot
  } : {};
  return /*#__PURE__*/_jsxs(StyledModal, Object.assign({
    ModalComponent: ModalComponent,
    "data-test-id": "communication-methods-modal",
    hideBackground: hideBackground,
    width: currentModalView === ASSIGNABLE ? 850 : 650,
    use: "conversational"
  }, optionalProps, {
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onClose()
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: currentModalView === GET_A_CALL ? /*#__PURE__*/_jsx(GetACallSection, {
        onBackClick: handleBackClick,
        upgradeData: upgradeData,
        handleIframeSizeChange: handleIframeSizeChange,
        isUpgradePoint: isUpgradePoint,
        repInfo: repInfo
      }) : /*#__PURE__*/_jsx(AssignableModalBody, {
        _overrideModalHeaderText: _overrideModalHeaderText,
        setCurrentModalView: setCurrentModalView,
        upgradeData: upgradeData,
        handleIframeSizeChange: handleIframeSizeChange,
        showChatButton: isFreeUser,
        onClose: onClose,
        isUpgradePoint: isUpgradePoint,
        repInfo: repInfo
      })
    })]
  }));
};
AssignableModal.defaultProps = {
  handleIframeSizeChange: () => {},
  hideBackground: false
};
AssignableModal.propTypes = Object.assign({
  handleIframeSizeChange: PropTypes.func,
  hideBackground: PropTypes.bool,
  isFreeUser: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  ModalComponent: PropTypes.elementType,
  _overrideModalHeaderText: PropTypes.string,
  _overrideCommunicationMethodKey: PropTypes.string,
  modalRoot: PropTypes.object,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);